import { AlpineComponent } from '@alpinejs/csp';

const Section = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'section__header--visible' : '';
  }
});

export default Section;
